{{#if this.currentUser.admin}}
  {{nav-item route="adminWizards" label="admin.wizard.nav_label"}}

  {{#if this.wizardErrorNotice}}
    {{d-icon "exclaimation-circle"}}
  {{/if}}
{{/if}}